/**
*
* Hero
*
*/

import styled from 'styled-components';
import { mediaMax } from 'themes/helpers';

export const StyledHeader = styled.header`
  background-size: cover;
  padding: 4em 3em;
  color: #fff;
  text-align: center;
  font-size: 10px;

  h1 {
    font-size: 6.5em;
    font-weight: bold;
    margin: 0 0 0.2em;
    color: inherit;
    letter-spacing: 1px;
    line-height: 1em;
    margin-bottom: 5px;
    text-transform: uppercase;
  }

  p {
    font-size: 2.6em;
    font-weight: bold;
    margin: 0;
    color: inherit;
    text-transform: uppercase;
  }

  h4 {
    font-size: 1.8em;
    font-weight: bold;
    margin: 0;
    color: inherit;
  }
  ${mediaMax.tablet`
    h1 {
      font-size: 5em;
    }
    p {
      font-size: 2em;
    }
  `}
  ${mediaMax.phoneL`
    h1 {
      font-size: 4em;
    }
    p {
      font-size: 1.8em;
    }
  `}
  ${mediaMax.phone`
    h1 {
      font-size: 3em;
    }
    p {
      font-size: 1.6em;
    }
  `}
`;

export default StyledHeader;



// WEBPACK FOOTER //
// ./src/components/PageHeader/index.js